import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getHL7Nodes, getPushbackOperations } from "../../utilities/HL7utils";

const ConfigPartThree = (props) => {
  const {
    handleClick,
    styles,
    step,
    isFormValid,
    reportAutoNode,
    setReportAutoNode,
    worklistPriorNode,
    setWorklistPriorNode,
    criticalFindNode,
    setCriticalFindNode,
    reportAuto,
    setReportAuto,
    worklistPrior,
    setWorklistPrior,
    criticalFind,
    setCriticalFind,
    aiStatusNode,
    setAiStatusNode,
    aiStatus,
    setAiStatus,
  } = props;

  const [pushbackOperations, setPushbackOperations] = useState([]);
  const [HL7Nodes, setHL7Nodes] = useState([]);

  useEffect(() => {
    const fetchHL7Nodes = async () => {
      const params = {};
      try {
        const data = await getHL7Nodes(params);
        setHL7Nodes(data?.items || []);
      } catch (error) {
        console.error(error);
      }
    };

    fetchHL7Nodes();
  }, []);

  useEffect(() => {
    const getPushbackOperation = async () => {
      try {
        const data = await getPushbackOperations();
        setPushbackOperations(data?.data?.version_list || []);
      } catch (error) {
        console.log(error);
      }
    };

    getPushbackOperation();
  }, []);

  const dropdownOptions = HL7Nodes.map((ins) => ({
    label: ins.name,
    value: ins.id,
  }));

  const handleOnChange = (value, actionMeta) => {
    const { name } = actionMeta;
    if (name === "Critical Findings") {
      setCriticalFindNode(value);
    } else if (name === "Report Auto Population") {
      setReportAutoNode(value);
    } else if (name === "Worklist Prioritization") {
      setWorklistPriorNode(value);
    } else if (name === "AI Status") {
      setAiStatusNode(value);
    }

  };

  const handleCheckedChange = (name) => {
    if (name === "Critical Findings") {
      setCriticalFind(!criticalFind);
      if (criticalFind) setCriticalFindNode(null);
    } else if (name === "Report Auto Population") {
      setReportAuto(!reportAuto);
      if (reportAuto) setReportAutoNode(null);
    } else if (name === "Worklist Prioritization") {
      setWorklistPrior(!worklistPrior);
      if (worklistPrior) setWorklistPriorNode(null);
    } else if (name === "AI Status") {
      setAiStatus(!aiStatus);
      if (aiStatus) setAiStatusNode(null);
    }
  };

  const getNodeValue = (name) => {
    if (name === "Critical Findings") {
      return criticalFindNode;
    } else if (name === "Report Auto Population") {
      return reportAutoNode;
    } else if (name === "Worklist Prioritization") {
      return worklistPriorNode;
    } else if (name === "AI Status") {
      return aiStatusNode;
    }
    return null;
  };

  // Determine if at least one checkbox is selected and its corresponding dropdown has a value selected
  const isNextButtonEnabled =
    (!criticalFind || (criticalFind && criticalFindNode)) &&
    (!reportAuto || (reportAuto && reportAutoNode)) &&
    (!worklistPrior || (worklistPrior && worklistPriorNode)) &&
    (!aiStatus || (aiStatus && aiStatusNode));

  return (
    <div>
      <div className="hl7-modal-inputs">
        {pushbackOperations.map((operation, index) => (
          <div
            key={index}
            className="d-flex justify-content-between flex-column mb-3 carpl_color"
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      operation === "Critical Findings"
                        ? criticalFind
                        : operation === "Report Auto Population"
                        ? reportAuto
                        : operation === "Worklist Prioritization"
                        ? worklistPrior
                        : aiStatus
                    }
                    onChange={() => handleCheckedChange(operation)}
                  />
                }
                label={operation}
              />
            </FormGroup>
            {((operation === "Critical Findings" && criticalFind) ||
              (operation === "Report Auto Population" && reportAuto) ||
              (operation === "Worklist Prioritization" && worklistPrior) ||
              (operation === "AI Status" && aiStatus)) && (
              <Select
                placeholder="Select HL7 Node"
                name={operation}
                options={dropdownOptions}
                onChange={handleOnChange}
                value={getNodeValue(operation)}
                isClearable={true}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: "5px",
                  colors: styles.colors,
                })}
                styles={{
                  container: (provided) => ({
                    ...provided,
                  }),
                  control: (provided) => ({
                    ...provided,
                    ...styles.controlStyles,
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: "black",
                    color: state.isSelected ? "#0fc4a0" : "white",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    fontWeight: "normal",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999, // Ensuring the menu appears on top
                    position: "relative",
                  }),
                }}
              />
            )}
          </div>
        ))}
      </div>

      <div className="d-flex justify-content-around">
        {step === 3 ? (
          <div className="d-flex justify-content-around">
            <div className="prev">
              <button
                className="btn-class mt-3"
                type="button"
                name="btn-click"
                style={{ marginLeft: "1rem", marginRight: "1rem" }}
                onClick={() => handleClick("prev")}
              >
                PREV
              </button>
            </div>
            <div className="submit-config">
              <button
                className="btn-class mt-3"
                type="button"
                name="btn-click"
                style={{ marginLeft: "1rem", marginRight: "1rem" }}
                onClick={() => handleClick("submit")}
                disabled={!isFormValid || !isNextButtonEnabled}
              >
                SUBMIT
              </button>
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-between">
            {step !== 0 && (
              <div>
                <button
                  className="btn-class mt-3"
                  type="button"
                  name="btn-click"
                  style={{ marginLeft: "1rem", marginRight: "1rem" }}
                  onClick={() => handleClick("prev")}
                >
                  PREV
                </button>
              </div>
            )}
            <div>
              <button
                className="btn-class mt-3 ml-2 mr-2"
                type="button"
                name="btn-click"
                style={{ marginLeft: "1rem", marginRight: "1rem" }}
                onClick={() => handleClick("next")}
                disabled={!isNextButtonEnabled}
              >
                NEXT
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfigPartThree;
